import { useEffect, useRef, useState } from "react";
import { ArrowheadDown, ArrowheadUp } from "../../icons";

function SettingsDropdownField({
    id,
    value,
    options = [],
    disabled = false,
    onChange,
}) {
    const [isOpen, setIsOpen] = useState(false);
    const rootRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (rootRef.current && !rootRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        function handleEscape(event) {
            if (event.key === "Escape") {
                setIsOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscape);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("keydown", handleEscape);
        };
    }, []);

    const selectedValue = value ?? "";
    const hasSelectedOption = options.includes(selectedValue);
    const displayValue = hasSelectedOption ? selectedValue : "Select an option";

    const handleSelect = (nextValue) => {
        onChange(nextValue);
        setIsOpen(false);
    };

    return (
        <div
            ref={rootRef}
            className={`settings-dropdown ${isOpen ? "is-open" : ""} ${disabled ? "is-disabled" : ""}`}
        >
            <button
                id={id}
                type="button"
                className="settings-dropdown-trigger"
                disabled={disabled}
                aria-haspopup="listbox"
                aria-expanded={isOpen}
                onClick={() => setIsOpen((prev) => !prev)}
            >
                <span className="settings-dropdown-value">{displayValue}</span>
                <span className="settings-dropdown-chevron" aria-hidden="true">
                    {isOpen ? (
                        <ArrowheadUp className="settings-dropdown-chevron-icon" />
                    ) : (
                        <ArrowheadDown className="settings-dropdown-chevron-icon" />
                    )}
                </span>
            </button>

            {isOpen && !disabled && (
                <div className="settings-dropdown-menu" role="listbox">
                    {options.map((option) => {
                        const isSelected = option === selectedValue;

                        return (
                            <button
                                key={option}
                                type="button"
                                role="option"
                                aria-selected={isSelected}
                                className={`settings-dropdown-option ${isSelected ? "is-selected" : ""}`}
                                onClick={() => handleSelect(option)}
                            >
                                {option}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default SettingsDropdownField;